import { Fragment, Suspense } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import isEmpty from "lodash-es/isEmpty"

import { EModalId, type IModal, useModalSelector } from "@/3514/store/modal"

import { modalWrapperClasses } from "./modal.styles"

type _TProps = { modalId: EModalId; container: LazyExoticComponent<FC> | FC }
const ModalContainer: FC<_TProps> = ({ modalId, container: Container }: _TProps): ReactElement => {
    const modal: IModal = useModalSelector(modalId)

    return (
        <Suspense fallback={<div className={modalWrapperClasses()} />}>
            {!isEmpty(modal) ? <Container key={modal.instanceKey} /> : <Fragment />}
        </Suspense>
    )
}

ModalContainer.displayName = "ModalContainer"

export { ModalContainer }
